import TriggeredEvent from './TriggeredEvent'
import PageEvent from './PageEvent'
import AddedEvent from './AddedEvent'
import TagEvent from './TagEvent'
import ConvoEvent from './ConvoEvent'
import NoteEvent from './NoteEvent'
import MeetingBookedEvent from './MeetingBookedEvent'
import VoiceCallEvent from './VoiceCallEvent'

const TimelineEvents = {
  TriggeredEvent,
  PageEvent,
  AddedEvent,
  TagEvent,
  ConvoEvent,
  NoteEvent,
  MeetingBookedEvent,
  VoiceCallEvent
}

export default TimelineEvents